<template>
  <tr class="row-details" v-if="readyToRender">
    <td class="v-align-middle"  colspan="6">
      <div class="cc-container">
        <customer 
          :customer="customer" 
          :is-details="isDetails"
        ></customer>

        <div class="cc-representatives">
          <div class="cc-representatives-head">
            <h4>Représentant(s) concerné(s)</h4>
          </div>

          <representative 
            :representative="validationRequestable"
            :current="true"
          ></representative>
        </div>
      </div>
    </td>

  </tr>
</template>

<script>
import { apiV2 } from 'store/api'
import Customer from "./ValidationRequestable/CustomerV2"
import Representative from "./ValidationRequestable/RepresentativeV2"

export default {
  name:"CustomerCreation",

  props:["validationRequestId", "isDetails"],

  components:{
    Customer,
    Representative,
  },

  data() {
    return {
      validationRequest: null
    }
  },

  computed:{
    readyToRender() {
      return this.validationRequest != null
    },

    customer() {
      return this.validationRequest.included.customer
    },

    validationRequestable() {
      return this.validationRequest.included.validation_requestable
    }
  },

  created() {
    const params = {
      with: 'customer,validation_requestable'
    }

    apiV2.getValidationRequest(this.validationRequestId, params)
      .then((response) => this.validationRequest = response.data.data)
  }
}
</script>

<style scoped>
.cc-container {
  display: flex;
}

.cc-container > div { margin-right: 15px; }
.cc-container > div:last-child { margin-right: 0; }

.cc-representatives {
  border:solid 1px lightgrey;
  padding: 0 15px;
  background-color: white;
  width: 100%;
}

.row-details td {
  background-color: #e0e0e0
}
</style>



// WEBPACK FOOTER //
// client/components/Demands/Details/CustomerCreation.vue